export const NxIdempotencyKey = 'NX-IDEMPOTENCY-KEY';